export const LOGO_URL = "/logo.png";

export const CONTACT = {
  email: "Info@acomep.be",
  phone: "02 315 83 28",
  phoneHref: "tel:+3223158328",
  tva: "TVA BE1017548707",
  location: "Belgique - Bruxelles, Wallonie & Flandre",
  whatsapp:
    "https://wa.me/32492367697?text=Bonjour%20ACOMEP%2C%20je%20souhaite%20un%20devis%20pour%20mon%20projet.",
};

export const NAV_LINKS = [
  { label: "Expertises", href: "#expertises" },
  { label: "Pourquoi nous", href: "#pourquoi" },
  { label: "À propos", href: "#apropos" },
  { label: "Réalisations", href: "#realisations" },
  { label: "Contact", href: "#contact" },
];

export const DOMAINS = [
  {
    id: "electricite",
    code: "SEC-01",
    title: "Électricité Générale & Tertiaire",
    description:
      "Conception, mise en œuvre et maintenance de vos installations électriques, en garantissant sécurité, performance et conformité aux normes en vigueur.",
    image:
      "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2FsJTIwZW5naW5lZXJpbmclMjBtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3OTA4NzQyNzV8MA&ixlib=rb-4.1.0&q=85",
    services: [
      {
        label: "Neuf & Rénovation",
        detail:
          "Installation complète de réseaux électriques pour logements, bureaux et bâtiments industriels.",
      },
      {
        label: "Mise en Conformité",
        detail:
          "Audit, remise aux normes et sécurisation des tableaux et équipements électriques.",
      },
      {
        label: "Éclairage & Puissance",
        detail:
          "Solutions d'éclairage LED basse consommation, colonnes montantes et gestion de la puissance.",
      },
    ],
  },
  {
    id: "domotique",
    code: "SEC-02",
    title: "Domotique & Bâtiment Intelligent",
    description:
      "Centralisez et automatisez le contrôle de votre habitat ou de vos locaux professionnels pour gagner en confort, en sécurité et en sobriété énergétique.",
    image:
      "https://images.unsplash.com/photo-1650682009477-52fd77302b78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGhvbWUlMjBhdXRvbWF0aW9uJTIwdGFibGV0JTIwcGFuZWx8ZW58MHx8fHwxNzkwODc0Mjc1fDA&ixlib=rb-4.1.0&q=85",
    services: [
      {
        label: "Gestion d'Éclairage & Ouvrants",
        detail:
          "Pilotage à distance des lumières, volets roulants, stores et accès via smartphone ou commandes centralisées.",
      },
      {
        label: "Scénarios d'Usage & Automatisation",
        detail:
          "Scénarios personnalisés : départ, présence, nuit, gestion automatique du chauffage et de la fraîcheur.",
      },
      {
        label: "Protocoles Standardisés & Évolutifs",
        detail:
          "Intégration de technologies filaires et sans fil modernes (KNX, Loxone, Zigbee…) pour une installation durable.",
      },
    ],
  },
  {
    id: "climatisation",
    code: "SEC-03",
    title: "Climatisation & Pompes à Chaleur",
    description:
      "Des solutions thermiques performantes et écologiques pour assurer votre confort en toute saison, été comme hiver.",
    image:
      "https://images.unsplash.com/photo-1700124113583-81aa99ea2aa2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxodmFjJTIwaGVhdCUyMHB1bXAlMjBzeXN0ZW0lMjBhaXIlMjBjb25kaXRpb25pbmd8ZW58MHx8fHwxNzkwODc0Mjc1fDA&ixlib=rb-4.1.0&q=85",
    services: [
      {
        label: "Pompes à Chaleur (Air/Eau & Air/Air)",
        detail:
          "Installation et remplacement de systèmes de chauffage économiques et écoresponsables.",
      },
      {
        label: "Climatisation Réversible",
        detail:
          "Mono-split & multi-split sur mesure pour habitations, bureaux et surfaces commerciales.",
      },
      {
        label: "Mise en Service & Entretien",
        detail:
          "Dimensionnement, recharge de fluide frigorigène, contrôle d'étanchéité et maintenance préventive.",
      },
    ],
  },
  {
    id: "ventilation",
    code: "SEC-04",
    title: "Ventilation & Traitement de l'Air",
    description:
      "Un air sain et une ventilation maîtrisée, essentiels pour le confort et la durabilité de vos bâtiments.",
    image:
      "https://images.unsplash.com/photo-1707596830261-9c6138a6dd3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHx2ZW50aWxhdGlvbiUyMGR1Y3QlMjBodmFjJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzkwODc0Mjc1fDA&ixlib=rb-4.1.0&q=85",
    services: [
      {
        label: "VMC Simple & Double Flux",
        detail:
          "Extraction et renouvellement d'air optimisés pour limiter les pertes thermiques.",
      },
      {
        label: "Ventilation Tertiaire & Industrielle",
        detail:
          "Conception de réseaux d'aération sur mesure pour locaux professionnels, bureaux et ateliers.",
      },
      {
        label: "Entretien & Filtration",
        detail:
          "Maintenance régulière des centrales de traitement d'air (CTA) et remplacement des filtres.",
      },
    ],
  },
  {
    id: "data",
    code: "SEC-05",
    title: "Câblage Data & Fibre Optique",
    description:
      "Une connectivité haut débit, fiable et évolutive pour répondre aux exigences numériques actuelles de vos infrastructures.",
    image:
      "https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxmaWJlciUyMG9wdGljJTIwbmV0d29yayUyMHNlcnZlciUyMGNhYmxpbmd8ZW58MHx8fHwxNzkwODc0Mjc1fDA&ixlib=rb-4.1.0&q=85",
    services: [
      {
        label: "Réseaux Informatiques",
        detail:
          "Déploiement de câblage structuré (Cat 6, Cat 6A, Cat 7) et pose de baies de brassage.",
      },
      {
        label: "Fibre Optique",
        detail:
          "Soudure, raccordement, réflectométrie et qualification de liaisons optiques intérieures et extérieures.",
      },
      {
        label: "Salles Serveurs & Data Centers",
        detail:
          "Organisation, repérage et optimisation de l'architecture réseau.",
      },
    ],
  },
  {
    id: "regulation",
    code: "SEC-06",
    title: "Régulation & Gestion Technique HVAC",
    description:
      "Optimisez le confort thermique tout en réduisant vos consommations grâce à une régulation intelligente du chauffage, de la ventilation et de la climatisation.",
    image:
      "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwZW5naW5lZXJpbmclMjBtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3OTA4NzQyNzV8MA&ixlib=rb-4.1.0&q=85",
    services: [
      {
        label: "Automatisme & Régulation",
        detail:
          "Programmation et installation de régulateurs et centrales de gestion HVAC.",
      },
      {
        label: "GTC / GTB",
        detail:
          "Pilotage centralisé et suivi en temps réel des équipements thermiques du bâtiment.",
      },
      {
        label: "Optimisation Énergétique",
        detail:
          "Réglage précis des lois d'eau, des débits d'air et des consignes pour minimiser vos factures d'énergie.",
      },
    ],
  },
];

export const REALISATIONS = [
  {
    id: "tableaux",
    code: "CH-01",
    title: "Tableaux & distribution électrique",
    place: "Bruxelles",
    image:
      "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwcGFuZWwlMjBpbnN0YWxsYXRpb24lMjBlbGVjdHJpY2lhbnxlbnwwfHx8fDE3OTA4NzU0NTN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "pac",
    code: "CH-02",
    title: "Pompe à chaleur air/eau",
    place: "Brabant Wallon",
    image:
      "https://images.unsplash.com/photo-1776860155275-eee24bfb1dee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6ODl8MHwxfHNlYXJjaHwxfHxoZWF0JTIwcHVtcCUyMEhWQUMlMjB0ZWNobmljaWFuJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc5MDg3NTQ1M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "fibre",
    code: "CH-03",
    title: "Câblage & fibre optique",
    place: "Liège",
    image:
      "https://images.unsplash.com/photo-1594915440248-1e419eba6611?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxmaWJlciUyMG9wdGljJTIwY2FibGluZyUyMHRlY2huaWNpYW4lMjByYWNrfGVufDB8fHx8MTc5MDg3NTQ1M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "vmc",
    code: "CH-04",
    title: "Réseaux de ventilation",
    place: "Namur",
    image:
      "https://images.unsplash.com/photo-1707596830261-9c6138a6dd3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHx2ZW50aWxhdGlvbiUyMGR1Y3R3b3JrJTIwSFZBQyUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3OTA4NzU0NTN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "domotique",
    code: "CH-05",
    title: "Installation domotique",
    place: "Anvers",
    image:
      "https://images.unsplash.com/photo-1636569608385-58efc32690ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzV8MHwxfHNlYXJjaHwzfHxzbWFydCUyMGhvbWUlMjBhdXRvbWF0aW9uJTIwd2FsbCUyMHNjcmVlbiUyMHBhbmVsfGVufDB8fHx8MTc5MDg3NTQ1N3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "industriel",
    code: "CH-06",
    title: "Chantier industriel",
    place: "Charleroi",
    image:
      "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHszfHxlbGVjdHJpY2FsJTIwcGFuZWwlMjBpbnN0YWxsYXRpb24lMjBlbGVjdHJpY2lhbnxlbnwwfHx8fDE3OTA4NzU0NTN8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const MARQUEE_ITEMS = [
  "Conformité RGIE",
  "Normes PEB",
  "KNX · Loxone · Zigbee",
  "Cat 6A / Cat 7",
  "Fibre Optique",
  "GTB / GTC",
  "Pompes à Chaleur",
  "VMC Double Flux",
  "Intervention Belgique",
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1619218070141-bcfeb8b93074?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2FsJTIwZW5naW5lZXJpbmclMjBtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3OTA4NzQyNzV8MA&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1622571451950-8d7b3fa342d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2FsJTIwZW5naW5lZXJpbmclMjBtb2Rlcm4lMjBidWlsZGluZ3xlbnwwfHx8fDE3OTA4NzQyNzV8MA&ixlib=rb-4.1.0&q=85";
